<template>
  <div class="my-4 flex">
    <a
      :href="href"
      class="border font-bold py-3 px-8 rounded-full transition-all duration-200 ease-in-out"
      :class="[getColorClasses(), getAlign()]"
    >
      <span class="text-headline font-medium text-sm">
        <slot></slot>
      </span>
    </a>
  </div>
</template>

<script>
export default {
  name: "RoHButton",
  props: {
    color: {
      type: String,
      default: "",
    },
    bgcolor: {
      type: String,
      default: "transparent",
    },
    href: {
      type: String,
      default: "",
    },
    align: {
      type: String,
      default: "",
    },
  },
  methods: {
    getColorClasses() {
      if (this.bgcolor === "transparent") {
        if (this.color === "rc-blue") {
          return "border-rc-blue text-rc-blue hover:text-white hover:bg-rc-blue";
        }
        if (this.color === "h-orange") {
          return "border-h-orange text-h-orange hover:text-white hover:bg-h-orange";
        }
        if (this.color === "white") {
          return "border-white text-white hover:bg-h-orange ";
        }
      }
      if (this.bgcolor === "h-orange") {
        return "bg-h-orange text-white hover:border-h-orange hover:bg-white hover:text-h-orange";
      }
      if (this.bgcolor === "rc-blue") {
        return "bg-rc-blue text-white hover:border-rc-blue hover:bg-white hover:text-rc-blue";
      }
    },
    getAlign() {
      if (this.align === "right") {
        return "ml-auto";
      }
      if (this.align === "left") {
        return "mr-auto";
      }
    },
  },
};
</script>

<style scoped></style>
